import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../service/auth.service';
import { ActivatedRoute } from '@angular/router';
import { ActionState } from '../../model/enums/auth-state.enum';
import { AuthMessageResponse } from '../../model/interfaces/auth-message-response.interface';
import { fadeInGlideDown, fadeInGlideUp } from '../../../shared/utils/animations';
import { firstValueFrom } from 'rxjs';
/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  standalone: false,
  animations: [fadeInGlideDown(), fadeInGlideUp()],
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordComponent implements OnInit {
  protected authService = inject(AuthService);
  private route = inject(ActivatedRoute);

  user: string | null = null;
  token: string | null = null;
  state: ActionState = ActionState.PENDING;
  messages: AuthMessageResponse[] = [];
  form: FormGroup;

  constructor() {
    this.form = new FormGroup(
      {
        newPassword1: new FormControl('', [Validators.required, Validators.minLength(3)]),
        newPassword2: new FormControl('', [Validators.required, Validators.minLength(3)]),
      },
      { validators: this.authService.validatorPasswordMatch },
    );
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.user = params['user'];
      this.token = params['token'];
    });
  }

  readonly icons = {
    bAdguard: 'fa-shield-check',
    actionRedo: 'fa-arrow-rotate-right',
    pencil: 'fa-pencil',
  };

  async onSubmit() {
    this.authService.handleFormAction(this);
    const resetData = {
      newPassword1: this.form.controls['newPassword1'].value || '',
      newPassword2: this.form.controls['newPassword2'].value || '',
      uidb64: this.user || '',
      token: this.token || '',
    };

    try {
      // await this.authService.resetPassword(resetData);
      await firstValueFrom(this.authService.resetPassword(resetData));
      this.authService.setState(this, ActionState.SUCCESS);
      // TODO: specify return type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      const errorMessages = Array.isArray(error) ? error : [error];
      this.authService.finalizeAction(this, ActionState.FAILURE, errorMessages);
    }
  }
}
